var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ScrollableContainerWithStickyHeader"},[_c('div',[_c('div',{ref:"header",staticClass:"headerContainer"},[_vm._t("header")],2),_c('div',{staticClass:"bodyContainer"},[_vm._t("body")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }